import React, { Suspense } from 'react';
import { Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { UserEdit } from './user-edit/UserEdit';
import SearchUserPage from './SearchUserPage';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './UsersUtils';




const UsersPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.users }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/user")) {
    const temp = menuList.find(q => q.url == "/user")
    isFullAccess = temp.isFullAccess;
  }

  const otherTabs = [
    // { id: 1, title: "ASID.TABS.AUDIT.FORMS", tab: 'userDorm'},
    // { id: 2, title: "ASID.TABS.CULLINAN", tab: 'userCulinan'},
    // { id: 3, title: "MODULES.BASEINFO.ROLE.PERMISSION_MENU", tab: 'menuAccess'},
  ];


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          {/* {
          <Redirect
            exact={true}
            from="/users"
            to="/user"
          />
        } */}

          {/* <ContentRoute path="/user/search"
          render={props => <SearchUserPage />}
        /> */}


          <ContentRoute path="/user/new"
            render={props =>
              <UserEdit {...props} isFullAccess={isFullAccess} basePath="/user" api="api/user" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} otherTabs={otherTabs} />}
          />

          <ContentRoute
            path="/user/:id/edit"
            render={props =>
              <UserEdit {...props} isFullAccess={isFullAccess} basePath="/user" api="api/user" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} otherTabs={otherTabs} />}
          />

          <ContentRoute
            path="/user"
            render={props => <ObjectsPage {...props} isFullAccess={isFullAccess} basePath="/user" api="api/user" currentState={currentState}
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} haveChangePasswordAction={true} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default UsersPage



